// Where this SDK sends requests. Override per environment with VITE_PROFILE_API_HOST
// (e.g. http://localhost:4003/profile during local development:
// the path prefix is part of the base URL).
const env = (import.meta as { env?: Record<string, string | undefined> }).env;

export default function getSdkHost(): string {
  const configuredHost = env?.VITE_PROFILE_API_HOST;
  return configuredHost !== undefined && configuredHost !== ""
    ? configuredHost
    : "https://api.sportsmet.com/profile";
}
